import * as type from './mutation-types'
export const state = {
    status: -9999,
    errmsg: '',
    advertiseList: {},
    loadingAL: '',
    productList: {},
    loadingPL: '',
    product: {},
    loadingPro: '',
    incomeDetail: {},
    loadingID: '',
    uBalance: {},
    loadingUB: '',
    payList: {},
    paying: '',
    purchaseHiList: {},
    purchasing: ''
}
export const mutations = {
    [type.ERROR_RECEIVE](state, res) {},
    [type.GETADVERTISELIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.advertiseList = {}
        state.loadingAL = 'loadingAL'
    },
    [type.GETADVERTISELIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.advertiseList = (res && res.content) || {}
        state.loadingAL = state.status > -9999 && 'loadedAL'
    },
    [type.GETPRODUCTLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.productList = {}
        state.loadingPL = 'loadingPL'
    },
    [type.GETPRODUCTLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.productList = (res && res.content) || {}
        state.loadingPL = state.status > -9999 && 'loadedPL'
    },
    [type.GETPRODUCT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.product = {}
        state.loadingPro = 'loadingPro'
    },
    [type.GETPRODUCT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.product = (res && res.content) || {}
        state.loadingPro = state.status > -9999 && 'loadedPro'
    },
    [type.GETINCOMEDETAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.incomeDetail = {}
        state.loadingID = 'loadingID'
    },
    [type.GETINCOMEDETAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.incomeDetail = (res && res.content) || {}
        state.loadingID = state.status > -9999 && 'loadedID'
    },
    [type.GETUSERBALANCE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.uBalance = {}
        state.loadingUB = 'loadingUB'
    },
    [type.GETUSERBALANCE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.uBalance = (res && res.content) || {}
        state.loadingUB = state.status > -9999 && 'loadedUB'
    },
    [type.PAY_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.payList = {}
        state.paying = 'paying'
    },
    [type.PAY_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.payList = (res && res.content) || {}
        state.paying = state.status > -9999 && 'payed'
    },
    [type.GETPURCHASEHI_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.purchaseHiList = {}
        state.purchasing = 'purchasing'
    },
    [type.GETPURCHASEHI_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.purchaseHiList = (res && res.content) || {}
        state.purchasing = state.status > -9999 && 'purchased'
    }
}